

























































































import Vue from "vue";
import { receiptsService } from "@/common/services/ReceiptsService";
import { AdminReceiptListItem } from "@/common/models/Receipt";
import CurrencyValue from "@/common/components/CurrencyValue.vue";
import { humanReadableDate } from "@/common/utils/DateUtils";
import DatePickerField from "@/common/components/DatePickerField.vue";

export interface ReceiptTableOptions {
  page: number;
  itemsPerPage: number;
  storeId?: string | null;
  userId?: string | null;
  from?: string | null;
  to?: string | null;
}

export default Vue.extend({
  name: "ReceiptsTable",
  components: {
    CurrencyValue,
    DatePickerField,
  },
  props: {
    options: {
      type: Object,
      default: (): ReceiptTableOptions => {
        return {
          page: 1,
          itemsPerPage: 10,
        };
      },
    },
    showStore: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: (): AdminReceiptListItem[] => [],
    },
    totalItems: {
      type: Number,
      default: Infinity,
    },
  },

  data() {
    const headerTranslationKeyPrefix = "modules.receipts.components.receipts-table.headers";
    return {
      headers: [
        { text: this.$t(`${headerTranslationKeyPrefix}.actions`), value: "actions" },
        this.showStore ? { text: this.$t(`${headerTranslationKeyPrefix}.storeName`), value: "storeName" } : undefined,
        { text: this.$t(`${headerTranslationKeyPrefix}.userId`), value: "userId" },
        { text: this.$t(`${headerTranslationKeyPrefix}.fullName`), value: "user.fullName" },
        { text: this.$t(`${headerTranslationKeyPrefix}.subTotal`), value: "calculatedPrice.subTotal" },
        { text: this.$t(`${headerTranslationKeyPrefix}.total`), value: "calculatedPrice.total" },
        {
          text: this.$t(`${headerTranslationKeyPrefix}.ubaContribution`),
          value: "calculatedPrice.ubaContribution",
        },
        { text: this.$t(`${headerTranslationKeyPrefix}.orderStatus`), value: "orderStatus" },
        { text: this.$t(`${headerTranslationKeyPrefix}.paymentType`), value: "paymentType" },
        { text: this.$t(`${headerTranslationKeyPrefix}.paymentStatus`), value: "paymentStatus" },
        { text: this.$t(`${headerTranslationKeyPrefix}.createdDate`), value: "createdDate" },
      ].filter((header) => header !== undefined),
      internalOptions: this.options,
      dialog: false as boolean,
      dates: [] as string[],
      storeId: null as number | null,
      userId: null as string | null,
      receiptsService: receiptsService,
    };
  },

  watch: {
    internalOptions: {
      handler(): void {
        this.$emit("update:options", this.internalOptions);
      },
      deep: true,
    },
    "$route.query": {
      handler(): void {
        this.internalOptions.storeId = this.$route.query.storeId ? parseInt(this.$route.query.storeId as string) : null;
        this.storeId = this.internalOptions.storeId;

        this.internalOptions.userId = this.$route.query.userId;
        this.userId = this.internalOptions.userId;

        this.internalOptions.from = this.$route.query.from;
        this.dates[0] = this.internalOptions.from;

        this.internalOptions.to = this.$route.query.to;
        this.dates[1] = this.internalOptions.to;
      },
      immediate: true,
    },
    dates: {
      handler(): void {
        this.updateQueryParams();
      },
      deep: true,
    },
  },

  methods: {
    humanReadableDate,

    clearFilters: function (): void {
      if (this.showStore) {
        this.storeId = null;
      }
      this.userId = null;
      this.dates = [];
      this.updateQueryParams();
    },

    updateQueryParams(): void {
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          storeId: this.storeId ? this.storeId.toString() : undefined,
          userId: this.userId ? this.userId : undefined,
          from: this.dates ? this.dates[0] : undefined,
          to: this.dates ? this.dates[1] : undefined,
        },
      });
    },

    viewReceipt(item: AdminReceiptListItem): void {
      this.$emit("viewReceipt", item.transactionId);
    },
  },
});
